import React, { useEffect, useState, useMemo } from "react";
import { db } from "../../../config/firebaseConfig"; // Firestoreの設定ファイルをインポート
import { collection, getDocs, query, where } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
// import "./tab05.css";
import { useTreeView } from "../../../context/treeViewContext";
import SummaryTable from "./summaryTable/summaryTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDoubleDown, faAngleDoubleUp } from "@fortawesome/free-solid-svg-icons";
import { data } from "jquery";
import { chunk } from "lodash";

const firestoreCollections = [
    // { collectionName: "01-1_electricTable", fieldName: "electricName", colorClass: "electric", displayName: "電気",filterKey: "electric", type: 'electricType' },
    // { collectionName: "02-1_networkTable", fieldName: "networkName", colorClass: "network", displayName: "ネットワーク", filterKey: "network", type: 'networkType' },
    // { collectionName: "03-1_airTable", fieldName: "airName", colorClass: "air", displayName: "給排気", filterKey: "air", type: 'airType' },
    { collectionName: "04-1_waterTable", fieldName: "waterName", colorClass: "water", displayName: "給排水", filterKey: "water", type: 'waterType' }
  ];

const Tab05 = ({selectedRow, setSelectedRow }) => {
  const [mergedData, setMergedData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false); // ローディング状態
  const { selectedAndChildIDList} = useTreeView();
  const [selectedFilters, setSelectedFilters] = useState({
    electric: true,
    air: true,
    water: true,
    network: true
  });
  const [isVisible, setIsVisible] = useState(true); 
  const navigate = useNavigate();
  const { deviceNameMap } = useTreeView();
  const currentProjectID = localStorage.getItem("currentProjectID");

  useEffect(() => {
  const fetchDataAndFilter = async () => {
    if (!selectedAndChildIDList || selectedAndChildIDList.length === 0) {
      setMergedData([]);
      setFilteredData([]);
      return;
    }

    setLoading(true);
    let allData = [];

    try {
      for (const { collectionName, fieldName, filterKey, displayName, colorClass, type } of firestoreCollections) {
        const idChunks = selectedAndChildIDList.length === 1
          ? [[selectedAndChildIDList[0]]]
          : chunk(selectedAndChildIDList, 30); // 🔹 30件ずつに分割

        for (const idList of idChunks) {
          const queryConstraint = [
            idList.length === 1
              ? where("masterID", "==", idList[0])
              : where("masterID", "in", idList),
            where("deleted", "==", false),
            where("projectID", "==", currentProjectID)
          ];

          const q = query(collection(db, collectionName), ...queryConstraint);
          const querySnapshot = await getDocs(q);

          const data = querySnapshot.docs.map((doc) => ({
            id: doc.id,
            masterID: doc.data().masterID || "N/A",
            uttID: doc.data().uttID || "N/A",
            name: doc.data()[fieldName] || "N/A",
            type: doc.data()[type] || "N/A",
            collectionName,
            colorClass,
            ...doc.data()
          }));

          allData = [...allData, ...data];
        }
      }

      setMergedData(allData);

      const filtered = allData
        .filter(item => selectedFilters[item.colorClass])
        .sort((a, b) => {
          const indexA = selectedAndChildIDList.indexOf(a.masterID);
          const indexB = selectedAndChildIDList.indexOf(b.masterID);

          if (indexA !== -1 && indexB !== -1) return indexA - indexB;
          if (a.masterID < b.masterID) return -1;
          if (a.masterID > b.masterID) return 1;
          if (a.uttID < b.uttID) return -1;
          if (a.uttID > b.uttID) return 1;
          return 0;
        });

      setFilteredData(filtered);
    } catch (error) {
      console.error("Firestore データの取得に失敗しました:", error);
    } finally {
      setLoading(false);
    }
  };

  fetchDataAndFilter();
}, [selectedAndChildIDList]); // 依存配列に selectedAndChildIDList を追加


  // フィルターボタンの切り替え
  const toggleFilter = (filterKey) => {
    setSelectedFilters((prevFilters) => ({
      ...prevFilters,
      [filterKey]: !prevFilters[filterKey], // 選択状態をトグル
    }));
  };

  // 行をクリックしたときの処理
  const handleRowClick = (masterID, data) => {
    setSelectedRow({ masterID, ...data });
  };
  
  // `selectedRow` の更新を監視し、変更後の値をログに出力
  useEffect(() => {
      if (selectedRow) {
      }
    }, [selectedRow]
  );
  

  // 編集ボタン押下時の処理（画面遷移）
  const handleEditClick = () => {
    if (selectedRow) {
      // navigate("/EditMaster", { state: selectedRow }); // 遷移先にデータを渡す
      navigate(`/EditMaster/${selectedRow.masterID}`, { state: { edit: true, data: selectedRow } });
    }
  };
  

    // summaryTable用のデータ処理
    const summaryData = useMemo(() => {
        return Object.values(mergedData.reduce((acc, item) => {
          if (!acc[item.type]) {
            acc[item.type] = { type: item.type, totalCapacity: 0, count: 0 };
          }
          acc[item.type].count++;
          acc[item.type].totalCapacity += item.capacity ? Number(item.capacity) : 0;
          return acc;
          }, {}));
    }, [mergedData]);

    //firestoreのtimestampを変換
    const formatDate = (timestamp) => {
      if (!timestamp) return '';
      const date = timestamp.toDate();
      const year = date.getFullYear();
      const month = (`0${date.getMonth() + 1}`).slice(-2); // 1月=0なので+1
      const day = (`0${date.getDate()}`).slice(-2);
      return `${year}/${month}/${day}`;
    };

  return (
    <>
    {/* サマリーエリア */}
      <div className="header-container">
          <button className="toggle-button" onClick={() => setIsVisible(!isVisible)}>
            <FontAwesomeIcon icon={isVisible ? faAngleDoubleUp : faAngleDoubleDown} />
          </button>
          <p>{isVisible ? "" :"←合計表の表示" }</p>
          <div className={`summary-area ${isVisible ? "visible" : "hidden"}`}>
            <SummaryTable summaryData={summaryData}/>
          </div>
      </div>
    {/* ボタン表示エリア */}
      
    
    {/* フィルターエリア * */}
    <div className="filter-area">
    </div>
  {/*テーブル  */}
      <div>
        {loading ? (
          <p className="loading">データ取得中...</p> // ローディング中の表示
        ) : (
        <table border="1" className="utilityTable">
          <thead>
            <tr>
              <th>ID</th>
              <th>装置名</th>
              <th>ユーティリティID</th>
              <th>名称</th>
              <th>種類</th>
              <th>容量[L/min]</th>
              <th>備考</th>
              <th>更新者</th>
              <th>更新日</th>
            </tr>
          </thead>
          <tbody>
            {filteredData.length > 0 ? (
              filteredData.map((item) => (
                <tr 
                  key={item.id} 
                  className={item.colorClass + (selectedRow?.id === item.id ? " selected" : "")}
                  onClick={() => handleRowClick(item.masterID, item)} // クリックで選択
                >
                  <td>{item.masterID}</td>
                  <td>{deviceNameMap[item.masterID]}</td>
                  <td>{item.uttID}</td>
                  <td>{item.name}</td>
                  <td>{item.type}</td>
                  <td>{item.capacity}</td>
                  <td>{item.remark1}</td>
                  <td>{item.updatedBy}</td>
                  <td>{formatDate(item.updatedAt)}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8">データがありません</td>
              </tr>
            )}
          </tbody>
        </table>
      )}
      </div>
    </>
  );
};

export default Tab05;
